// extracted by mini-css-extract-plugin
module.exports = {"list":"Menu-rtl_list__ZSViu","title":"Menu-rtl_title__3NOQu","menuItemActive":"Menu-rtl_menuItemActive__1Hxtn","activeCurve":"Menu-rtl_activeCurve__21WEQ"};